(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs-viewer', {
            parent: 'admin',
            url: '/logs-viewer',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs-viewer.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs-viewer/logs-viewer.html',
                    controller: 'LogsViewerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs-viewer');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
